<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="subBlockContainer" id="openorders">

  <div class="subBlockContent" *ngIf="!narrow">
    <child-header [title]="title"
                  [showDownload]="true"
                  titleDownload="Download Open Order"
                  (downloadEvent)="exportExcelForOpenOrder()"
                  [showClone]="true"
                  titleClone="Copy Invoiced Order link"
                  [showLoading]="showResultDownloading"
                  (cloneEvent)="ExportOpenOrderLink()"
                  (closeEvent)="close()"
    ></child-header>
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper" style="display: none;">
        <div class="title blade-title-font">
          {{title}}
          <!-- <span id="download-icon" placement="bottom"></span>
          <span id="file-icon" placement="bottom"></span> -->
        </div>
        <div class="basic-icon download-icon" style="transform: translate(0, 15%) !important;" placement="bottom"
             [class.blur-icon]="showResultDownloading"
             [ngbTooltip]="showResultDownloading? '': 'Download Open Order'" (click)="exportExcelForOpenOrder()">
        </div>
        <div class="basic-icon copy-icon" placement="bottom" [class.blur-icon]="showResultDownloading"
             [ngbTooltip]="showResultDownloading? '': 'Copy Invoiced Order link'" (click)="ExportOpenOrderLink()"></div>
        <div *ngIf="showResultDownloading" class="basic-icon downloading-icon-position">
          <mat-spinner mode="indeterminate" class="circle" diameter="20"></mat-spinner>
        </div>
        <!-- <i class="material-icons pullfloat-right" [routerLink]="['/myOrder']">close</i> -->
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div>

      <div class="filter-wrapper">
        <div class="col-md-12">
          <div class="searchInputGroup">
            <div class="searchIcon">
              <img src="../images/new_ui/filter.png">
            </div>
            <input class="searchInput" type="text" placeholder="Filter Orders" onfocus="this.placeholder=''"
                   onblur="this.placeholder='Filter Orders'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasEmptyFilterResult">
        <div style="margin-top: 20px;" class="noResult-wrapper">
          <div><img src="../images/new_ui/no-found.png"></div>
          <div>No results found</div>
          <div>Sorry, that filter combination has no results.<br>Please try different criteria.</div>
          <div>
            <button (click)="filterReset()" class="button button-red button-large">Try again</button>
          </div>
          <div class="noResult-feedback">Send Feedback</div>
        </div>
      </ng-container>

      <ng-container *ngIf="!hasEmptyFilterResult && orders">
        <div style="margin-top: 20px;" class="shared-outer-wrapper table-header-allign">
          <table matSort (matSortChange)="sortData($event)" class="white" nowrap>
            <thead>
            <tr class="row">
              <th mat-sort-header="orderNo" style="width:15%;padding-left:15px">ORDER NO</th>
              <th mat-sort-header="orderDate" style="width:15%;padding-left:12px">ORDER DATE</th>
              <th mat-sort-header="resellerPo" style="width:15%">RESELLER PO</th>
              <th mat-sort-header="orderStatus" style="width:15%">ORDER STATUS</th>
              <th mat-sort-header="holdReason" style="width:15%">HOLD REASON</th>
              <th mat-sort-header="totalEx" style="width:12%;padding-left:35px;">TOTAL EX</th>
              <th style="width:13%"></th>
            </tr>
            </thead>
          </table>
        </div>
        <div class="shared-outer-wrapper child-body">
          <table matSort (matSortChange)="sortData($event)" class="white" nowrap>
            <thead hidden="true">
            <tr class="row">
              <th mat-sort-header="orderNo" style="width:15%;padding-left:15px">ORDER NO</th>
              <th mat-sort-header="orderDate" style="width:15%;padding-left:12px">ORDER DATE</th>
              <th mat-sort-header="resellerPo" style="width:15%">RESELLER PO</th>
              <th mat-sort-header="orderStatus" style="width:15%">ORDER STATUS</th>
              <th mat-sort-header="holdReason" style="width:15%">HOLD REASON</th>
              <th mat-sort-header="totalEx" style="width:12%;padding-left:35px;">TOTAL EX</th>
              <th style="width:13%"></th>
            </tr>
            </thead>
            <tbody>
            <!--comment paginate-->
            <!-- <ng-container *ngFor="let order of sortedData | orderFilterPipe: filterInput | paginate: { itemsPerPage: 50, currentPage: p }"> -->
            <ng-container
              *ngFor="let order of sortedData | TableFilterMultiple:['orderNo', 'dateOrdered', 'resellerPO', 'orderStatus', 'holdReasonDescription'] : filterInput">
              <!-- <tr class="order-content-wrapper row "> -->
              <tr class="row inforow">
                <td style="width:15%;padding-left:15px">{{order?.orderNo}}{{order?.orderSuffix}}</td>
                <td style="width:15%;padding-left:12px">{{order?.dateOrdered.split("-").join("/")}}</td>
                <td style="width:15%">{{order?.resellerPO}}</td>
                <td style="width:15%">{{order?.orderStatus}}</td>
                <td style="width:15%">{{order?.holdReasonDescription}}</td>
                <!-- <td class="align-right" style="width:12%;padding-right: 23px;">
                  {{order?.totalEx | currency:'AUD':'symbol-narrow':'.2-2'}}</td> -->
                <td class="align-right" style="width:12%;padding-right: 23px;">
                  {{convertTotal(order?.totalEx) | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
                <td class="button-wrapper" style="width:13%; text-align: center">
<!--                  <a (click)="goOrderDetail(order)"-->
<!--                     class="red-link">Details</a>-->

                  <span class="return-link" (click)="goOrderDetail(order)" [class.active]="selectedOrder == order.orderNo+order.orderSuffix"
                  >Details</span>
                </td>
                <div class="row downloadrow">
                  <div class="downloadtextcol">DOWNLOAD DOCUMENTS:</div>
                  <div class="downloadiconcol">
                    <a [href]="order?.orderConfirmationUrl" target="_blank" *ngIf="order?.orderConfirmationUrl">
                      <!-- <img src="../images/new_ui/open-orders/order-confirmation-grey.png" placement="bottom"
                        ngbTooltip="Order Confirmation"> -->
                      <span class="basic-icon orderConfirm-icon" placement="bottom"
                            ngbTooltip="Order Confirmation"></span>
                    </a>
                    <a [href]="order?.creditNoteUrl" target="_blank" *ngIf="order?.creditNoteUrl">
                      <!-- <img src="../images/new_ui/open-orders/credit-note-grey.png" placement="bottom"
                        ngbTooltip="Credit Note"> -->
                      <span class="basic-icon creditNote-icon" placement="bottom" ngbTooltip="Credit Note"></span>
                    </a>

                    <a [href]="order?.deliveryDocketUrl" target="_blank" *ngIf="order?.deliveryDocketUrl">
                      <!-- <img src="../images/new_ui/open-orders/delivery-docket-grey.png" placement="bottom"
                        ngbTooltip="Delivery Docket"> -->
                      <span class="basic-icon deliveryDocket-icon" placement="bottom"
                            ngbTooltip="Delivery Docket"></span>
                    </a>
                    <a [href]="order?.invoiceUrl" target="_blank" *ngIf="order?.invoiceUrl">
                      <!-- <img src="../images/new_ui/open-orders/tax-invoice-grey.png" placement="bottom"
                        ngbTooltip="Tax Invoice"> -->
                      <span class="basic-icon taxInvoice-icon" placement="bottom" ngbTooltip="Tax Invoice"></span>
                    </a>
                    <a [href]="order?.licenceAgreeUrl" target="_blank" *ngIf="order?.licenceAgreeUrl">
                      <!-- <img src="../images/new_ui/open-orders/license-agreement-grey.png" placement="bottom"
                        ngbTooltip="License Agreement"> -->
                      <span class="basic-icon licenseAgreement-icon" placement="bottom"
                            ngbTooltip="License Agreement"></span>
                    </a>
                    <a [href]="order?.orderAmendUrl" target="_blank" *ngIf="order?.orderAmendUrl">
                      <!-- <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom"
                        ngbTooltip="Amendment"> -->
                      <span class="basic-icon amendment-icon" placement="bottom" ngbTooltip="Amendment"></span>
                    </a>
                    <a [href]="order?.podUrl" target="_blank" *ngIf="order?.podUrl">                     
                      <span class="basic-icon proofOfDelivery-icon" placement="bottom"
                        ngbTooltip="Proof of Delivery"></span>
                    </a>
                    <a [href]="order?.rmaUrl" target="_blank" *ngIf="order?.rmaUrl">                    
                      <span class="basic-icon returnAuthority-icon" placement="bottom"
                        ngbTooltip="Return Authority"></span>
                    </a>
                    <a [href]="order?.resellerPOUrl" target="_blank" *ngIf="order?.resellerPOUrl">                     
                      <span class="basic-icon purchaseOrder-icon" placement="bottom"
                        ngbTooltip="Purchase Order"></span>
                    </a>
                    <a [href]="order?.supportConUrl" target="_blank" *ngIf="order?.supportConUrl">                     
                      <span class="basic-icon supportAgreement-icon" placement="bottom"
                        ngbTooltip="Support Agreement"></span>
                    </a>  
                    <a *ngIf="order?.hasSerials ==='1'" target="_blank"
                          (click)="exportOrderSerials(order?.orderNo, order?.orderSuffix)">                       
                          <span class="basic-icon orderSerials-icon" placement="bottom"
                            ngbTooltip="Export Serials"></span>
                        </a>
                    <a [href]="order?.autopilotUrl" target="_blank" *ngIf="order?.autopilotUrl">
                      <!-- <img src="../images/new_ui/open-orders/amendment-grey.png" placement="bottom"
                        ngbTooltip="Amendment"> -->
                      <span class="basic-icon autopilot-icon" placement="bottom" ngbTooltip="Autopilot"></span>
                    </a>                   
                  </div>
                  <div class="payButton">
                    <button *ngIf="order.showPayNowBtn" class="button button-red button-mid"
                            (click)="payOrder(order)">Pay now
                    </button>
                    <!-- <a *ngIf="order.showPayNowBtn" class="list-group-item" style="padding-left: 24px">Pay now</a> -->
                  </div>
                </div>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>
        <!-- <pagination-controls (pageChange)="p = $event" directionLinks="true" previousLabel="" nextLabel="" class="search-pagination"></pagination-controls> -->
      </ng-container>
    </div>

    <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
    </loading-screen>
  </div>


  <div class="blockContainer narrow-sidebar narrow-sidebar-overflow" id="levelTwo"
       *ngIf="narrow">

    <div class="combination-loader">

      <div class="child-sidebar sidebar-loader">
        <child-header [title]="title" (closeEvent)="close()"></child-header>

        <div class="child-body renewal-list-mini">
          <div class="searchInputGroup">
            <div class="searchIcon search-carts">
              <img src="../images/site-icons/search-red.svg">
            </div>
            <input class="searchInput searchInputGroup-small" type="text"
                   placeholder="Search Invoice Number" onfocus="this.placeholder=''"
                   onblur="this.placeholder='Filter Orders'" [(ngModel)]="filterInput" (ngModelChange)="onChange()">
          </div>
          <ng-container
            *ngFor="let order of sortedData | TableFilterMultiple:['orderNo', 'dateOrdered', 'resellerPO', 'orderStatus', 'holdReasonDescription'] : filterInput">
            <!--            [class.active]="selectedSerial == item.out_serial"-->
            <div class="menu-wrapper menu-wrapper-position"
                 (click)="goOrderDetail(order)" [class.active]="selectedOrder === order.orderNo+order.orderSuffix">
              <!--                 (click)="goReturnsDetail(order)"-->
              <!--                 [class.active]="selectedOrder == order.orderNo+'-'+order.orderSuffix"-->

              <div class="total-div">
                <div class="narrow-title truncate">
                  {{ order?.orderNo}}{{order?.orderSuffix}}
                </div>
                <span class="narrow-text">
                                     Date:{{order?.dateOrdered.split("-").join("/")}}
                  | Total:{{convertTotal(order?.totalEx) | currency:'AUD':'symbol-narrow':'.2-2'}}
                                  </span><br>

                <!-- <span class="narrow-text">
                {{item.out_opportunity_id}}</span> -->
              </div>
            </div>

          </ng-container>
          <loading-screen *ngIf="!loadContent" [showBlurTable]="true" (currentLoadingStatus)="onLoading($event)">
          </loading-screen>

        </div>
      </div>

      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>

    </div>

  </div>

</div>


